<div
  class="chip"
  matTooltip="there are active flags in this deliverable"
  matTooltipPosition="above"
  matTooltipShowDelay="1000"
>
  active flags
</div>
